var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"parent_avatar",on:{"click":_vm.handleClick}},[_c('Avatar',{staticStyle:{"margin":"0 auto","padding":"0"},attrs:{"username":_vm.username,"src":_vm.srcUrl,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }